module.exports = __webpack_public_path__ + "static/innovate-101178f2b87c820b1fee73ed105da8ad.mp4";